import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Root from "@/Root";
import Chat from "@/components/Chat/Chat";
import GroupChat from "@/components/GroupConversation/GroupChat";
import JoinGroupChat from "@/components/GroupConversation/JoinGroupChat";
import Store from "@/components/CustomGPT/Store";
import EditCustomGPT from "@/components/CustomGPT/EditCustomGPT";
import AgentsHome from "@/components/Agents/AgentsHome";
import EditAgent from "@/components/Agents/EditAgent";
import Library from "@/components/Library/Library";
import PublicImages from "@/components/PublicImages/PublicImages";
import ErrorPage from "@/components/Error/ErrorPage";

const routes = [
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <Chat />
      },
      {
        path: "c/:conversationId",
        element: <Chat />
      },
      {
        path: "gc/:conversationId",
        element: <GroupChat />
      },
      {
        path: "gc/join/:conversationId",
        element: <JoinGroupChat />
      },
      {
        path: "share/:conversationId",
        element: <Chat />
      },
      {
        path: "g/:gptId",
        element: <Chat />
      },
      {
        path: "spaces",
        element: <Store />
      },
      {
        path: "spaces/v/:gptId",
        element: <Store />
      },
      {
        path: "spaces/c",
        element: <EditCustomGPT />
      },
      {
        path: "spaces/e/:gptId",
        element: <EditCustomGPT />
      },
      {
        path: "agents",
        element: <AgentsHome />
      },
      {
        path: "agents/v/:agentId",
        element: <AgentsHome />
      },
      {
        path: "agents/c",
        element: <EditAgent />
      },
      {
        path: "agents/e/:agentId",
        element: <EditAgent />
      },
      {
        path: "library",
        element: <Library />
      },
      {
        path: "public-images",
        element: <PublicImages />
      },
    ]
  },
];

const router = createBrowserRouter(routes);

export default function App() {
  return (
    <RouterProvider router={router} />
  );
}
